import { ServiceFetch } from './service-fetch'

export default class LineLiffModel extends ServiceFetch {
    getLineLiffBy = (data) => this.authFetch({
        url: 'line-liff/getLineLiffBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}